/**
 * 站点卡 / 动态流上的人话(纯函数,零 React)。
 * ★ 这里只把契约字段翻成中文,不编数、不自己拼时间戳以外的东西。
 */
import type { DomainOverallStatus, SiteStatus } from "../api/types";

export const SITE_STATUS_LABEL: Record<SiteStatus, string> = {
  draft: "草稿 · 未发布",
  published: "已上线",
  archived: "已归档",
};

/**
 * 主域名一行的状态说明(屏 1 官网卡「自有域名 · HTTPS 已生效」那一格),按 §6 状态链逐态给话。
 * `live` 之外都是「还在路上」,让用户知道去域名绑定页看哪一步。
 */
export const DOMAIN_STATUS_TEXT: Record<DomainOverallStatus, string> = {
  unbound: "自有域名 · 未绑定",
  dns_pending: "自有域名 · 待配置 DNS",
  verifying: "自有域名 · 验证中",
  verified: "自有域名 · 已验证,待 CNAME",
  dns_checking: "自有域名 · CNAME 检测中",
  issuing: "自有域名 · 证书签发中",
  live: "自有域名 · HTTPS 已生效",
  error: "自有域名 · 配置有误",
};

/**
 * {@link DOMAIN_STATUS_TEXT},模拟发布(站点 `publisherMode === "stub"`)时不说「证书 / HTTPS」(附录 A.38):
 * stub 网关没签任何证书,域名 live 只是「解析对了、模拟上线」。
 */
export function domainStatusText(status: DomainOverallStatus, simulated = false): string {
  if (simulated && status === "live") return "自有域名 · 已上线(模拟发布)";
  if (simulated && status === "issuing") return "自有域名 · 上线中";
  return DOMAIN_STATUS_TEXT[status];
}

/**
 * 「09-21 18:42」—— 卡上和动态流要的是哪天几点,不要秒和时区。
 * ★ 只做字面切分不过 `Date`:api 给的是业务时区的本地时间 `yyyy-MM-ddTHH:mm:ss`(不带时区后缀,api
 *   `WebsiteViews.ts`),过 Date 会按看页面那台机器的时区解释、跟着漂;带 `+08:00` 的写法也照样切得出来。
 *   认不出格式回空串,调用方据此整段不渲染 —— 一串 ISO 出现在卡上读的人只会以为页面坏了。
 */
export function monthDayTime(ts?: string | null): string {
  const m = /^\d{4}-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(ts ?? "");
  return m ? `${m[1]}-${m[2]} ${m[3]}:${m[4]}` : "";
}

/** `https://qingshan.site.xbgeo.com/` → `qingshan.site.xbgeo.com`(卡上「平台预览域名」那一行)。 */
export function previewHost(url: string): string {
  return url.replace(/^[a-z]+:\/\//i, "").replace(/\/.*$/, "");
}

/** 「1,284」—— KPI 数字的千分位;只在真有数时调用(null 由页面画成「尚未接入」)。 */
export function kpiNumber(n: number): string {
  return n.toLocaleString("zh-CN");
}
